import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";

const environment = getEnvironment();

interface FreeMyDayBookingPayload {
    booking_key: string;
    discount: number;
}

export interface FreeMyDayPayload {
    date: string; // YYYY-MM-DD
    reason?: string;
    bookings: FreeMyDayBookingPayload[];
}

export default class AIAdmin {
    public static readonly freeMyDay = async (
        uuid: string,
        brand: string,
        location: string,
        payload: FreeMyDayPayload
    ): Promise<
        { ok: true; updated: number } | { ok: false; error: string }
    > => {
        try {
            const res = await axios.post(
                `${environment.api_url}/aiadmin/${brand}/location/${location}/free-my-day`,
                payload,
                {
                    headers: {
                        "User-Token": uuid,
                    },
                }
            );

            return {
                ok: true,
                updated: res.data.updated ?? 0,
            };
        } catch (err: any) {
            console.error("AIAdmin.freeMyDay error:", err);

            const message =
                err?.response?.data?.error ||
                err?.message ||
                "Unknown error from server.";

            return {
                ok: false,
                error: message,
            };
        }
    };

    public static readonly fillMyDay = async (
        uuid: string,
        brand: string,
        location: string,
        payload: {
            date: string;
            discount: number;
            target: {
                waitlist: boolean;
                statuses: string[];
            };
        }
    ): Promise<{ ok: boolean; error?: string }> => {
        try {
            await axios.post(
                `${environment.api_url}/aiadmin/${brand}/location/${location}/fill-my-day`,
                payload,
                { headers: { "User-Token": uuid } }
            );
            return { ok: true };
        } catch (err: any) {
            return {
                ok: false,
                error: err.response?.data?.error || "Request failed",
            };
        }
    };

    public static readonly fillMyDayStatus = async (
        uuid: string,
        brand: string,
        location: string,
        date: string // YYYY-MM-DD
    ): Promise<
        | { ok: true; jobExists: boolean; bookingEnabled: boolean }
        | { ok: false; error: string }
    > => {
        try {
            const res = await axios.get(
                `${environment.api_url}/aiadmin/${brand}/location/${location}/fill-my-day/status`,
                {
                    headers: { "User-Token": uuid },
                    params: { date },
                }
            );

            const { job_exists, booking_enabled } = res.data;

            return {
                ok: true,
                jobExists: job_exists,
                bookingEnabled: booking_enabled,
            };
        } catch (err: any) {
            console.error("AIAdmin.fillMyDayStatus error:", err);

            return {
                ok: false,
                error: err.response?.data?.error || "Request failed",
            };
        }
    };
}
